<template>
  <b-modal
    v-bind="$attrs"
    v-on="$listeners"
    :size="size"
    :header-bg-variant="headerBgVariant"
    header-text-variant="dark"
    button-size="lg"
    cancel-variant="outline-primary"
    footer-class="buttons"
  >
    <template #modal-header="{ close }">
      <slot name="modal-title">
        <h2 :class="['modal__title', headerClass]">{{ title }}</h2>
      </slot>
      <!-- Emulate built in modal header close button action -->
      <b-button
        v-if="!hideHeaderClose"
        size="sm"
        variant="outline-primary"
        class="modal__close"
        @click="close()"
      >
        <Icon name="boldClose" />
      </b-button>
    </template>
    <slot> </slot>
  </b-modal>
</template>

<script>
import Icon from "@/components/Icon/Icon";

/**
 * Use bootstrap-vue v-modal attributes to
 */
export default {
  name: "Modal",
  components: { Icon },
  props: {
    size: { type: String, default: "lg" },
    title: { type: String, default: "" },
    headerBgVariant: { type: String, default: "white" },
    hideHeaderClose: { type: Boolean, default: false },
    headerClass: { type: String, default: "" },
  },
  mounted() {},
  methods: {
    // close() {
    //   this.$emit("close");
    // }
  },
};
</script>
